import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureLithologies } from "../../../hooks/Capture";
import CaptureLithologies from "../Lithology/CaptureLithologies";

interface LithologyTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const LithologyTab: React.FC<LithologyTabProps> = ({ captureId, handleError, canEdit }) => {
  const { lithologiesData, isPending, createLithology, updateLithology, deleteLithology, refetch } = useCaptureLithologies(captureId);

  if (isPending && lithologiesData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CaptureLithologies
      captureId={Number(captureId)}
      lithologiesData={lithologiesData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createLithology(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateLithology({ lithologyId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteLithology(id).catch(handleError);
      }}
      onRequestRefresh={refetch}
    />
  );
};

export default LithologyTab;
